import type { FC } from 'react';

import { GridContainer, GridItem, Icon, Typography, useFormatTimeDistance } from '@cofenster/web-components';

type VideoDescriptionProps = {
  title: string | null;
  createdAt: number;
};

export const VideoDescription: FC<VideoDescriptionProps> = ({ title, createdAt }) => {
  const formatTimeDistance = useFormatTimeDistance();
  const date = formatTimeDistance(new Date(createdAt));

  return (
    <GridContainer spacing={0} display="flex" alignItems="center" data-testid="shared-video-description">
      <GridItem xs={0.5} display="flex" justifyContent="center" ml={1} mr={1}>
        <Icon type="AccountIcon" size="m" background={{ size: 'xl', color: 'linen50' }} />
      </GridItem>
      <GridItem padding={0} ml={1}>
        <GridContainer direction="column" spacing={0} display="flex">
          <GridItem padding={0}>
            <Typography component="p" variant="h6">
              {title}
            </Typography>
          </GridItem>
          <GridItem padding={0}>
            <Typography component="p" variant="m">
              {date}
            </Typography>
          </GridItem>
        </GridContainer>
      </GridItem>
    </GridContainer>
  );
};
